import './styles.scss'

const Tag = (props) => {

    return (
        <div className="tag-container">
            {
                props.new &&
                <div className="tag new">
                    New Listing
                  {/*<img src="/wp-content/themes/hayden/assets/images/icons/new-listing.svg" alt="new listing" />*/}
                </div>
            }
            {
                props.reduced &&
                <div className="tag reduced">
                    Price Reduced
                  {/*<img src="/wp-content/themes/hayden/assets/images/icons/reduced.svg" alt="price reduced" />*/}
                </div>
            }
            {
                props.buyerRepresented &&
                <div className="tag buyerRepresented">
                    Buyer Represented
                </div>
            }
        </div>
    )
}

export default Tag;
